import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import api from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { GlobalProductBanner } from "@/components/GlobalProductBanner";
import { EditableProvider, E } from "@/components/Editable";
import { DeviceProvider, useAutoDevice, resolveBlock, useViewportWidth, REF_W } from "@/components/Device";
import { OneMoreFx } from "@/components/OneMoreFx";
import { IntroLoader } from "@/components/IntroLoader";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { SurpriseMe } from "@/components/SurpriseMe";

export function StoreLayout() {
  const [chrome, setChrome] = useState({});
  const device = useAutoDevice();
  const vw = useViewportWidth();
  const sc = (b) => Math.min(1.15, vw / ((device === "desktop" ? b?.ref_w : null) || REF_W[device]));
  const zoomOf = (b) => (b && Object.keys(b.elements || {}).length ? { zoom: sc(b) } : undefined);
  useEffect(() => {
    api.get("/layouts/_chrome/published").then(({ data }) => {
      const m = {};
      (data.blocks || []).forEach((b) => { m[b.type] = b; });
      setChrome(m);
    }).catch(() => {});
  }, []);
  return (
    <DeviceProvider device={device}>
    <div className={`flex min-h-screen flex-col ${device === "mobile" ? "overflow-x-clip" : ""}`} data-device={device} data-fullw-root>
      <div style={zoomOf(chrome.header)} className="sticky top-0 z-[60] overflow-x-clip" data-testid="header-zoom"><EditableProvider blockId="header" elements={chrome.header ? resolveBlock(chrome.header, device).elements : {}}><Header /></EditableProvider></div>
      <EditableProvider blockId="header" elements={chrome.header ? resolveBlock(chrome.header, device).elements : {}}><E id="productbanner" label="Produktbanner (Udforsk vores godter)" display="block"><GlobalProductBanner /></E></EditableProvider>
      <main className={`flex-1 ${device === "mobile" ? "pb-16" : ""}`}><Outlet /></main>
      <div style={zoomOf(chrome.footer)} className="overflow-x-clip"><EditableProvider blockId="footer" elements={chrome.footer ? resolveBlock(chrome.footer, device).elements : {}}><Footer /></EditableProvider></div>
      <CartDrawer />
      <MobileBottomNav />
      <SurpriseMe />
      <OneMoreFx />
      <IntroLoader />
    </div>
    </DeviceProvider>
  );
}
